import React from 'react';

import './Button.css';
import { clsx } from 'clsx';

import LoadingSpinner from '../loading/spinner';

export type ButtonProps = {
	variant?: 'primary' | 'secondary' | 'link' | 'transparent';
	small?: boolean;
	label: React.ReactNode;
	isLoading?: boolean;
	disabled?: boolean;
	onClick?: () => void;
	className?: string;
};

export const Button: React.FC<ButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>> = ({
	variant = 'primary',
	label,
	isLoading = false,
	disabled,
	className,
	small,
	...rest
}) => {
	const combinedClasses = clsx(
		'button',
		`button--${variant}`,
		isLoading && 'button--isLoading',
		disabled && 'button--disabled',
		small && 'button--small',
		className
	);

	return (
		<button
			aria-label={isLoading ? label?.toString() || 'button-loading' : undefined}
			className={combinedClasses}
			disabled={disabled || isLoading}
			type="button"
			onClick={rest.onClick}
			{...rest}
		>
			<span className={isLoading ? 'hidden-text' : ''}>{label}</span>
			{isLoading && <LoadingSpinner />}
		</button>
	);
};
